import { render, staticRenderFns } from "./ContactListSubscriptionsView.vue?vue&type=template&id=0f0e3662"
import script from "./ContactListSubscriptionsView.vue?vue&type=script&lang=js"
export * from "./ContactListSubscriptionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports